import React from 'react';
import { Formik, Form } from 'formik';
import Modal from '../../audi-ui-components/Modal';
import IconSystemHelp from '../../audi-ui-components/icons/SystemHelp';
import Spinner from '../../audi-ui-components/Spinner';
import Button from '../../audi-ui-components/Button';
import FormField from './FormField';
import VINHelp from '../VINHelp';
import { request } from '../../functions/apiRequestHelper';
import { validate } from '../../functions/validation';
import { formatNumber } from '../../functions/textFormatting';
import { FIELD_SELECT, STATES_OPTIONS } from '../../constants';
// import "./vehiclesearch.scss";

/*
 * PROPS
 * vin: prefill vin field
 * lookupUrl
 * onLookupVin: (response, vehicle, lookupType)=>{}
 * onLookupVinNotFound: (error, vehicle, lookupType)=>{}
 * onClickVinHelp: ()=>{}
 * submitBtnText: string
 * regoLookup: boolean, show/hide rego lookup
 * mileage: boolean, show/hide kms fields
 * getRequestBody: (vehicle)=>{ return {} }
 *
 * TODO:
 * replace the search on BuyServicePlan with this component
 */

class VehicleSearchForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showVinHelp: false,
            serverError: null,
            regoNotFound: false
        }
    }

    validateForm = (values) => {
        if (!values.vin && !values.rego) {
            return {
                vin: "Please enter your registration number or VIN",
                rego: "Please enter your registration number or VIN"
            };
        }
        let schema = {};
        if (values.vin) {
            schema = {
                vin: { isVin: { message: "Please enter a valid VIN" } }
            };
            if (this.props.mileage) {
                schema.vinMileage = { presence: { message: "This field is required", allowEmpty: false } };
            }
        } else {
            schema = {
                rego: { presence: { message: "Please enter your registration number", allowEmpty: false } },
                regoState: { presence: { message: "Please select a state", allowEmpty: false } }
            };
            if (this.props.mileage) {
                schema.regoMileage = { presence: { message: "This field is required", allowEmpty: false } };
            }
        }
        return validate(values, schema, {format: "firstError", fullMessages: false});
    }

    submitForm = (values, formikBag) => {
        this.setState({serverError: null, regoNotFound: false});
        if (values.vin) {
            this.lookupVin({vin: values.vin, mileage: values.vinMileage}, formikBag, "vin");
        } else {
            request(
                `${process.env.RAZZLE_API_HOST}/2/services/vehicle/${values.rego}/${values.regoState}`,
                {
                    method: 'POST',
                }
            ).then(response => {
                // console.log(response);
                if (response.vin) {
                    this.lookupVin(
                        {vin: response.vin, mileage: values.regoMileage, regoPlate: values.rego, regoState: values.regoState},
                        formikBag,
                        "rego"
                    );
                } else {
                    this.setState({regoNotFound: true});
                }
            }).catch(error => {
                // console.error(error);
                if (error.status === 404) {
                    this.setState({regoNotFound: true});
                } else {
                    let msg = "An error has occured";
                    if (error.message) {
                        msg = error.message;
                    } else if (error.body && error.body.message) {
                        msg = error.body.message;
                    }
                    this.setState({serverError: msg});
                }
                formikBag.setSubmitting(false);
            });
        }
    }

    lookupVin = (vehicle, formikBag, lookupType) => {
      let reqBody = vehicle;
      if (typeof this.props.getRequestBody === "function") {
        reqBody = this.props.getRequestBody(vehicle);
      }
      request(
        this.props.lookupUrl,
        {
          method: 'POST',
          body: JSON.stringify(reqBody),
        }
      ).then(response => {
        // success
        if (typeof this.props.onLookupVin === "function") {
          this.props.onLookupVin(response, vehicle, lookupType);
        }
      }).catch(error => {
        // error
        // console.error(error);
        formikBag.setSubmitting(false);
        if (error.status === 404) {
          if (typeof this.props.onLookupVinNotFound === "function") {
            this.props.onLookupVinNotFound(error, vehicle, lookupType);
          }
        } else {
          let msg = "An error has occured";
          if (error.message) {
            msg = error.message;
          } else if (error.body && error.body.message) {
            msg = error.body.message;
          }
          this.setState({serverError: msg});
        }
      });
    }

    render() {
        return (
            <div className="vehiclesearch mb-5">
                {this.props.children}
                <Formik initialValues={this.props.vin ? {vin: this.props.vin} : {}} validate={this.validateForm} onSubmit={this.submitForm}>
                    {formikBag => (
                        <Form className="position-relative">
                            {formikBag.isSubmitting && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
                            <div className="row">
                                {this.props.regoLookup && <div className="col-12 col-medium-5">
                                    <p className="aui-headline-4 mb-3">Enter your registration details</p>
                                    <FormField name="rego" label="Registration number" formikBag={formikBag} />
                                    <FormField name="regoState" label="Registration state" fieldType={FIELD_SELECT} options={STATES_OPTIONS} formikBag={formikBag} />
                                    {this.props.mileage && <FormField name="regoMileage" label="Number of KM's" formatValue={formatNumber} formikBag={formikBag} />}
                                    {this.state.regoNotFound && <p className="py-3 aui-color-text-red">We can't find a matching Audi VIN with the registration number you have entered. Please try entering the VIN directly.</p>}
                                </div>}
                                {this.props.regoLookup && <div className="col-12 col-medium-2">
                                    <div className="or aui-headline-5"><span>OR</span></div>
                                </div>}
                                <div className="col-12 col-medium-5">
                                    <p className="aui-headline-4 mb-3">Enter your Vehicle Identification Number (VIN)</p>
                                    <FormField name="vin" label="VIN" formikBag={formikBag} />
                                    <p>
                                      <IconSystemHelp small /> Not sure how to find your VIN? <span className="aui-textlink" onClick={() => {
                                        this.setState({showVinHelp: true});
                                        if (typeof this.props.onClickVinHelp === "fucntion") { this.props.onClickVinHelp(); }
                                      }}>Find out how.</span>
                                    </p>
                                    {this.props.mileage && <FormField name="vinMileage" label="Number of KM's" formatValue={formatNumber} formikBag={formikBag} />}
                                </div>
                            </div>
                            {this.state.serverError && <p className="my-5 aui-color-text-red">{this.state.serverError}</p>}
                            <p className="mt-5">
                                <Button label={this.props.submitBtnText} buttonType="primary" type="submit" />
                            </p>
                        </Form>
                    )}
                </Formik>

                <Modal isActive={this.state.showVinHelp} modalStyle="layer" closeButton close={() => { this.setState({showVinHelp: false}); }}>
                    <VINHelp />
                </Modal>
            </div>
        );
    }
}

export default VehicleSearchForm;
